import React from 'react';
import ThemeToggle from './ThemeToggle';

/** Shared frame for the sign-in and sign-up pages: brand image panel, logo, heading. */
export default function AuthLayout({ title, subtitle, testId, logoClass = 'h-48', children }) {
  return (
    <div className="min-h-screen flex" data-testid={testId}>
      {/* Left side - Image */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img
          src="/images/Background.png"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-brand/20 to-aqua/10 flex flex-col justify-between p-12">
          <div />
          {/* Tagline bottom */}
          <div>
            <h1 className="text-4xl font-bold text-white mb-3 leading-tight drop-shadow-lg" style={{ fontFamily: 'Outfit', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
              Partners Portal
            </h1>
            <p className="text-white text-lg leading-relaxed drop-shadow-md" style={{ textShadow: '0 1px 6px rgba(0,0,0,0.7)' }}>
              Your gateway to global education opportunities.<br />
              Empowering advisors worldwide.
            </p>
          </div>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="auth-panel relative flex-1 flex items-center justify-center p-8">
        <ThemeToggle className="absolute top-5 right-5" />
        <div className="w-full max-w-md animate-fade-in-up">
          {/* Logo centred above form */}
          <div className="flex flex-col items-center mb-8">
            <img
              src="/images/Logo.png"
              alt="XpertAdvisor"
              className={`${logoClass} w-auto object-contain mb-4 drop-shadow-sm`}
            />
            <h2 className="text-2xl font-semibold text-ink text-center" style={{ fontFamily: 'Outfit' }}>{title}</h2>
            <p className="text-sm text-ink-2 mt-1 text-center">{subtitle}</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
